import _ from "lodash";
import * as z from "../../../framework";
import * as realTimeUpdates from "./realTimeUpdates";
import { Options } from "@msidata/service-pro-api-schema";
import { AnyVistaCode } from "../../../framework";

/*
* buildCodesRegistry
* Function will build all the codes available to the app
*
*/
export function buildCodesRegistry(options: any[]) {
    var deferred = $.Deferred();

    var localizeCodes = (function (array) {
        array.forEach(function (value) {
            var code = value.CodeNumber,
                previousValue = value.Value;

            value.Value = z.ll(code, true);

            if (value.Value == undefined && code != "" && z.settings.showDebugMessages) {
                z.controls.alert({
                    type: "danger",
                    header: "Localized Language Missing",
                    message: "Add a localized language entry for the code: " + code,
                    fade: false
                });
            }
            value.Value = previousValue || "No Localized Language Found";
        });
    });

    var orderCodesBySortOrder = () => {
        let tempCodes = _.mapValues(z.codes, (codeList) => {
            return _.sortBy(codeList, "SortOrder");
        });

        _.assign(z.codes, tempCodes);
    };

    if (localStorage.codes) {
        _.assign(z.codes, $.parseJSON(z.getLocalStorage("codes")));

        if (z.codes) {
            if (z.codes.ContractStatus) {
                localizeCodes(z.codes.ContractStatus);
            }
            if (z.codes.NoteType) {
                localizeCodes(z.codes.NoteType);
            }
            if (z.codes.CallAction) {
                localizeCodes(z.codes.CallAction);
            }
            if (z.codes.QuestionType) {
                localizeCodes(z.codes.QuestionType);
            }
            if (z.codes.EquipmentField) {
                localizeCodes(z.codes.EquipmentField);
            }
        }

        realTimeUpdates.openConnection();
        deferred.resolve();
    } else {
        z.ajax({
            cache: true,
            type: "GET",
            url: "Code/GetAllDictionary"
        }).done(function (data, status) {
            var results = data.d.results,
                keys = Object.keys(results);

            $.each(keys, function (index, key) {
                results[key] = _.sortBy(results[key], ["IsDeleted", "SortOrder"]);

                if (key != "CallAction" && key != "Division") {
                        results[key].unshift({
                        CodeNumber: "",
                        Value: "",
                        Id: -1,
                        Deleted: true,
                        IsDeleted: true,
                        SortOrder: 0
                    });
                } else if (key == "Division") {
                    results[key].unshift({
                        DivisionNumber: "Global",
                        DivisionName: "Global Division",
                        Id: null,
                        SortOrder: 0
                    });
                }
            });

            _.assign(z.codes, results);

            if (z.codes) {
                if (z.codes.ContractStatus) {
                    localizeCodes(z.codes.ContractStatus);
                }
                if (z.codes.NoteType) {
                    localizeCodes(z.codes.NoteType);
                }
                if (z.codes.CallAction) {
                    localizeCodes(z.codes.CallAction);
                }
                if (z.codes.QuestionType) {
                    localizeCodes(z.codes.QuestionType);
                }
                if (z.codes.EquipmentField) {
                    localizeCodes(z.codes.EquipmentField);
                }
            }

            orderCodesBySortOrder();

            deferred.resolve();

            try {
                z.setLocalStorage("codes", JSON.stringify(z.codes));
            } catch (e) {
                console.log(`error caching codes: ${e}`);
            }
        }).fail(function (e) {
            deferred.reject(e);
        });
    }

    return deferred.promise();
}

export function extendCode(codeName) {
    return z.ajax({
        type: "GET",
        url: "" + codeName + "?$top=10000"
    }).done(function (data) {
        $.each(data.d.results, function (i, extendedCode) {
            var found = false;
            $.each(z.codes[codeName], function (j, code) {
                if (code.CodeNumber == extendedCode.CodeNumber) {
                    found = true;
                    $.extend(code, extendedCode);
                }
            });
            if (!found) {
                z.codes[codeName].push(extendedCode);
            }
        });
    });
}

export function buildVistaCodesRegistry(optionIsVista?: Options) {
    let deferred = $.Deferred();
    if (localStorage.vistaCodes) {
        _.assign(z.vistaCodes, $.parseJSON(z.getLocalStorage("vistaCodes")));
        deferred.resolve(z.vistaCodes);
    } else if (optionIsVista?.Value.toLowerCase() === "true") {
        const allVistaCodes = [];
        z.ajax({
            type: "GET",
            url: "VistaCode/GetDictionaryWithFilter"
        })
        .then(resp => {
            allVistaCodes.push(...resp.d.results);
            z.ajax({
                type: "GET",
                url: "VistaCode/GetAllDictionary"
            })
            .then(resp2 => {
                allVistaCodes.push(...resp2.d.results);
                _.assign(z.vistaCodes, _.zipObject(allVistaCodes.map(c=>c.Key), allVistaCodes.map(c=>c.Value)));
                try {
                    z.setLocalStorage("vistaCodes", JSON.stringify(z.vistaCodes));
                } catch (e) {
                    console.log(`error caching vista codes: ${e}`);
                }
                deferred.resolve(z.vistaCodes);
            });
        })
        .fail(err => deferred.reject(err));
    } else {
        deferred.resolve();
    }

    return deferred;
}

export const populateVistaCodeCombobox = (uiElement: JQuery, codeName: AnyVistaCode["entityName"]) => {
    const kendoComboBox = uiElement.data("kendoComboBox");
    const codes = z.vistaCodes[codeName];
    const ds = new kendo.data.DataSource({data: codes});
    kendoComboBox && kendoComboBox.setDataSource(ds);
}
